// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"577":"7c751f1e","787":"7ea0274a","794":"4780f567"}[chunkId] + ".chunk.js";
};